var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDineIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-DineIn",
    clipPath: "url(#clip0_169_9229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7536 11.3427C15.9435 11.5604 16.03 11.8496 15.9907 12.1359C15.9367 12.5302 15.7736 13.1234 15.5419 13.6337C15.4263 13.8884 15.2685 14.179 15.0593 14.4223C14.8717 14.6403 14.4865 15 13.9094 15H2.0906C1.51354 15 1.12824 14.6403 0.94067 14.4222C0.731356 14.1789 0.573639 13.8883 0.45804 13.6336C0.226381 13.1232 0.0633577 12.53 0.00928635 12.1359C-0.0299837 11.8497 0.0564677 11.5604 0.246375 11.3427C0.436283 11.125 0.711085 11 1.00001 11H15C15.2889 11 15.5637 11.125 15.7536 11.3427ZM15 12H1.00001C1.03352 12.2443 1.13235 12.6313 1.27604 13C1.4779 13.518 1.76831 14 2.0906 14H13.9094C14.2316 14 14.5221 13.518 14.7239 13C14.8676 12.6313 14.9665 12.2444 15 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.16675C4.96243 6.16675 2.5 8.62918 2.5 11.6667H1.5C1.5 8.0769 4.41015 5.16675 8 5.16675C11.5899 5.16675 14.5 8.0769 14.5 11.6667H13.5C13.5 8.62918 11.0376 6.16675 8 6.16675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6V4H8.5V6H7.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6 3.5C6 3.22386 6.22386 3 6.5 3H9.5C9.77614 3 10 3.22386 10 3.5C10 3.77614 9.77614 4 9.5 4H6.5C6.22386 4 6 3.77614 6 3.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_9229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineIn);
export default __webpack_public_path__ + "static/media/dine-in.7cb438bbee0c66fcd285469345e62658.svg";
export { ForwardRef as ReactComponent };